module.exports = __webpack_public_path__ + "static/img/income-variable.a5ee6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cashflow-tour/income-variable.png
// module id = EIq6
// module chunks = 6